import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getHoldingOwnerSchemaAdditionalFields,
  holdingOwnerSchema,
} from "./holding-owner";
import { surrealRecordSchema } from "./surreal-record";

export const holdingSchema = surrealRecordSchema.extend({
  owners: z.array(holdingOwnerSchema),
  fromDate: z.coerce.date(),
  toDate: z.coerce.date().optional(),
  customName: z.string().optional(),
  additionalData: additionalDataSchema,
});

export type Holding = z.infer<typeof holdingSchema>;

export function getHoldingSchemaAdditionalFields(additionalFields: {
  holding: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof holdingSchema {
  return holdingSchema.extend({
    owners: z.array(getHoldingOwnerSchemaAdditionalFields(additionalFields)),
    additionalData: additionalFields.holding,
  });
}
